import mailTemplates from 'plugins/i18n/mailTemplates.de.ts'

export default {
	management: {
		sync: {
			dataUpdate: 'Datenaktualisierung',
		},
		analysis: {
			rate: 'Tarif',
			currentRateInfo:
				'Ihr derzeitiger Tarif beinhaltet {storage} Speicherplatz und {units} Einheiten. Verwenden Sie nach einer Datenaktualisierung mehr als 80 oder 90% Ihres Tarifs, erhalten Sie jeweils eine Information an Ihre hinterlegte E-Mail-Adresse. Sollten Sie 100% des Tarifs erreichen, werden automatisch weitere 50GB zu Ihrem Kontingent hinzugefügt oder das nächste Einheiten-Paket aktiviert.',
			availablePercent: 'Verfügbar in %',
			usedPercent: 'Verbraucht in %',
		},
		user: {
			usage: 'Nutzung',
			accessOverview:
				'Grafische Auswertung der Zugriffe im definierten Zeitraum. Bitte beachten Sie, dass nur eindeutige Anmeldungen ausgewertet werden. Das bedeutet, ein erneuter Aufruf Ihrer Seite mit bereits erfolgter Anmeldung, wird nicht gewertet.',
			lastSevenDays: 'Letzten 7 Tage',
			lastThirtyDays: 'Letzten 30 Tage',
			currentMonth: 'Aktueller Monat',
			lastMonth: 'Letzter Monat',
			currentYear: 'Aktuelles Jahr',
			lastYear: 'Letztes Jahr',
		},
		documenttypes: {
			documentTypeDistribution:
				'Grafische Auswertung der Verteilung Ihrer Dokumente auf Ihre Dokumentenarten',
			// Export
			export: 'Export',
			markForExport: 'Für Aaremo freigeben',
			unmarkForExport: 'Aus Aaremo entfernen',
			markForExportTitle: 'Dokumentenarten für Export markieren',
			unmarkForExportTitle: 'Dokumentenarten vom Export entfernen',
			markForExportDescription:
				'Sie sind dabei, {count} Dokumentenart für den Export aus Karthago zu markieren. | Sie sind dabei, {count} Dokumentenarten für den Export aus Karthago zu markieren.',
			unmarkForExportDescription:
				'Sie sind dabei, {count} Dokumentenart vom Export zu entfernen. | Sie sind dabei, {count} Dokumentenarten vom Export zu entfernen.',
			markForExportDisclaimer:
				'Das Markieren von Dokumentenarten für den Export exportiert entsprechende Ordner aus dem Karthago-Dokumentenmanagementsystem. Stellen Sie sicher, dass alle Einstellungen korrekt sind, bevor Sie bestätigen.',
			unmarkForExportDisclaimer:
				'WARNUNG: Das Entfernen von Dokumentenarten vom Export entfernt die entsprechenden Dokumente aus dem Aaremo-Portal.',
			whatHappensMarkItem1:
				'Dokumentenarten werden als "für Export vorgeschlagen" markiert',
			whatHappensMarkItem2:
				'Entsprechende Dateien werden nach Aaremo hochgeladen',
			whatHappensMarkItem3:
				'Dokumente können in diese Ordnerstrukturen in Karthago eingeordnet werden',
			whatHappensUnmarkItem1:
				'Dokumentenarten werden von der Exportliste entfernt',
			whatHappensUnmarkItem2:
				'Entsprechende Dateien werden aus Aaremo entfernt',
			whatHappensUnmarkItem3:
				'Dokumente in diesen Ordnern müssen möglicherweise neu organisiert werden',
			confirmMark: 'Bestätigen & für Export markieren',
			confirmUnmark: 'Bestätigen & Demarkieren',
			exportStatusUpdateError:
				'Fehler beim Aktualisieren des Exportstatus. Bitte versuchen Sie es erneut.',
			confirmMarkForExport:
				'Möchten Sie {count} Dokumentenart für Export markieren? | Möchten Sie {count} Dokumentenarten für Export markieren?',
			confirmUnmarkForExport:
				'Möchten Sie {count} Dokumentenart vom Export entfernen? | Möchten Sie {count} Dokumentenarten vom Export entfernen?',
			exportModalTitle: 'Dokumentenarten Export',
			selectedDocumentTypesExportMessage:
				'{count} Dokumentenart ausgewählt | {count} Dokumentenarten ausgewählt',
			exportModalDescription:
				'Markieren oder demarkieren Sie die ausgewählten Dokumentenarten für den Export. Sie können Ihre Auswahl unten verfeinern.',
			currentExportStatus: 'Aktueller Exportstatus',
			markedForExport: 'Für Export markiert',
			notMarkedForExport: 'Nicht für Export markiert',
			// Cutoff (per document type document age limit)
			cutoffModalTitle: 'Dokumentenalter Stichtag setzen',
			cutoffModalDescription:
				'Setzen Sie ein maximales Alter (in Jahren) und/oder einen festen Stichtag pro Dokumentenart. Ist ein Stichtag gesetzt, hat dieser Vorrang vor der Jahres-Angabe.',
			cutoffModalUploadHint:
				'Dokumente in diesen Ordnern werden ab dem eingestellten Datum erfasst und nach Aaremo hochgeladen — ältere Dokumente werden übersprungen.',
			cutoffMaxAgeYearsLabel: 'Max. Alter (Jahre, 1–50)',
			cutoffDateLabel: 'Stichtag (optional)',
			cutoffApply: 'Auf Auswahl anwenden',
			cutoffNoValue:
				'Bitte geben Sie ein Maximalalter oder einen Stichtag an.',
			cutoffUpdateError:
				'Fehler beim Aktualisieren der Stichtage. Bitte versuchen Sie es erneut.',
			cutoffApplyButtonLabel: 'Stichtag setzen',
			cutoffMaxAgeYearsPreview: 'Entspricht Stichtag {date} (jeweils 01.01.)',
			cutoffDateOverridesYears:
				'Ein gesetzter Stichtag hat Vorrang vor dem Maximalalter.',
			cutoffMixedValuesHint:
				'Die Auswahl enthält unterschiedliche Werte — leerlassen behält die jeweilige Einzeleinstellung.',
			cutoffModeMaxAge: 'Nach Alter (rollender Stichtag)',
			cutoffModeMaxAgeHint: 'Heute minus N Jahre, aktualisiert sich mit der Zeit.',
			cutoffModeFixedDate: 'Fester Stichtag',
			cutoffModeFixedDateHint: 'Konkretes Datum, ändert sich nicht automatisch.',
			cutoffCurrentMaxAge: 'aktuell: max. {years} Jahre',
			cutoffCurrentFixedDate: 'aktuell: Stichtag {date}',
			cutoffCurrentNone: 'aktuell: kein Stichtag',
			displayNameLabel: 'Anzeigename (optional)',
			displayNameHint:
				'Falls gesetzt, wird dieser Name in der Oberfläche statt der Bezeichnung aus dem System angezeigt. Leerlassen, um die Originalbezeichnung zu verwenden.',
			displayNameOriginalLabel: 'Originalbezeichnung',
			// Bulk-Edit (vereinheitlichte Maske, ersetzt Export + Stichtag + Versandeinstellungen)
			bulkEdit: 'Bulk-Bearbeiten',
			bulkEditModalTitle:
				'Bulk-Bearbeiten — {count} Dokumentenart | Bulk-Bearbeiten — {count} Dokumentenarten',
			bulkEditIntroTitle: 'So funktioniert die Bulk-Bearbeitung',
			bulkEditApplyHint:
				'Aktivieren Sie die Checkbox links eines Feldes, um den Wert auf alle ausgewählten Dokumentenarten anzuwenden. Felder ohne Häkchen bleiben unverändert.',
			bulkEditMixedHintExample:
				'= ungleiche Werte in der Auswahl (z. B. 13 von 22 Dokumentenarten haben „Versand" aktiviert, 9 nicht).',
			bulkEditSectionExport: 'Export & Stichtag',
			bulkEditSectionExportHelp:
				'Steuert welche Dokumentenarten an Aaremo exportiert werden und ab welchem Datum Dokumente erfasst werden. Max. Alter und fester Stichtag schließen sich gegenseitig aus.',
			bulkEditSectionDispatch: 'Versand & Benachrichtigung',
			bulkEditSectionDispatchHelp:
				'Push-Benachrichtigungen für neue Dokumente in der Mobile-App. „Wochen" begrenzt die Benachrichtigung auf Dokumente jünger als die angegebene Anzahl Wochen.',
			cutoffSectionHelp:
				'Ab welchem Datum Dokumente dieser Art an Aaremo übertragen werden. Wählen Sie entweder ein rollendes Maximalalter (z. B. 6 Jahre = ab 01.01. heuer minus 6) oder ein festes Datum. Dokumente, die älter sind als der Stichtag, werden übersprungen.',
			bulkEditApply: 'auf Auswahl anwenden',
			bulkEditCutoffMutex:
				'Max. Alter und fester Stichtag schließen sich aus — nur eines der beiden kann angewendet werden.',
			bulkEditUpdateError:
				'Fehler beim Bulk-Update der Dokumentenarten. Bitte versuchen Sie es erneut.',
		},
		buildingVisibility: {
			subtitle: 'Ausgeblendete Objekte verwalten (Karthago)',
			onlyKarthago:
				'Diese Funktion ist nur für Karthago-Mandanten verfügbar.',
			introLead:
				'Hier verwalten Sie ausschließlich Objekte, die {highlight} sind. Zum Export markierte Objekte werden weiterhin vollständig synchronisiert und tauchen hier nicht auf.',
			introHighlight: 'nicht zum Aaremo-Export freigegeben',
			introCascade:
				'Ausgeblendete Objekte verschwinden aus der Liegenschaften-Liste und allen Gebäude-Auswahl-Komponenten. Bestehende Meldungen, Aufträge, Personen, Notizen und Belegprüfungen bleiben davon unberührt.',
			save: 'Speichern',
			savePending: 'Speichern ({count})',
			filterAll: 'Alle ({count})',
			filterVisible: 'Sichtbar ({count})',
			filterHidden: 'Ausgeblendet ({count})',
			search: 'Suche',
			show: 'Einblenden',
			showCount: 'Einblenden ({count})',
			hide: 'Ausblenden',
			hideCount: 'Ausblenden ({count})',
			colFirma: 'Firma',
			colObjNr: 'ObjNr',
			colAddress: 'Adresse',
			colStatus: 'Status',
			statusHidden: 'Ausgeblendet',
			statusVisible: 'Sichtbar',
			savedSuccess: 'Sichtbarkeit gespeichert',
		},
		roles: {
			buildingAccess: 'Zugriff auf die Liegenschaft',
			documenttypeAccess: 'Zugriff auf alle Dokumentenarten',
			documenttypeAccessIndividual: 'Zugriff auf einzelne Dokumentenarten',
			roleAccess: 'Zugriff auf alle Personenfunktionen',
			roleAccessIndividual: 'Zugriff auf einzelne Personenfunktionen',
			invoiceAccess: 'Zugriff auf die Rechnungen',
			invoiceAccessAssigned: 'Zugriff auf angewiesene Rechnungen',
			journalAccountsAccess: 'Zugriff auf die Buchungskonten',
			personalAccounts: 'Persönliche Buchungskonten',
			personalAccountsAccess: 'Zugriff auf persönliche Buchungskonten',
			unitAccess: 'Zugriff auf die Einheit',
			addressLinkRequired: 'Adressverknüpfung erforderlich',
			cisTypeAccess: 'Zugriff auf alle Z.I.S. Arten',
			cisTypeAccessIndividual: 'Zugriff auf einzelne Z.I.S. Arten',
			taskTypeAccess: 'Zugriff auf alle WVL Arten',
			taskTypeAccessIndividual: 'Zugriff auf einzelne Wiedervorlage Arten',
			visibility: 'Sichtbarkeit / Öffentlich',
			rolesVisible: 'Sichtbar für alle Personenfunktionen',
			roleVisible: 'Sichtbar für einzelne Personenfunktion',
			copySettings:
				'Kopieren Sie die Einstellungen, um diese bei einer anderen Personenfunktion zu übernehmen',
			unlimitedAccess: 'unbegrenzter Zugriff',
			fromStartofRole: 'ab Beginn der PFkt',
			faqAccess: 'Zugriff auf die FAQs',
		},
		settings: {
			list: 'Liste',
			tiles: 'Kacheln',
			group_tiles: 'Gruppe-Kacheln',
			group_list: 'Gruppe-Liste',
			module: 'Module',
			functions: 'Funktionen',
			functionsInfo:
				'Folgende Funktionen können für die Nutzer freigeschaltet werden.',
			dataUpdateRequests: 'Datenänderungsanfragen',
			reportAutoAssignment:
				'Automatische Zuweisung von Meldungen an Objektsachbearbeiter',
			programAreas: 'Programmbereiche',
			programAreasInfo:
				'Folgende Programmbereiche können für die Nutzer freigeschaltet werden, die entsprechenden Daten werden aus HausPerfekt übernommen und gegebenenfalls auch zurückgeschrieben.',
			meterReadingManagement: 'Zählerstandsverwaltung',
			journalAccounts: 'Buchungskonten',
			personalAccounts: 'Persönliche Buchungskonten',
			options: 'Optionen',
			hidePropertyInformation: 'Liegenschaftsinformationen ausblenden',
			defaultViews: 'Standardansichten',
			theDocuments: 'der Dokumente',
			thePersons: 'der Personen',
			theBuildings: 'der Liegenschaften',
			colors: 'Farben',
			welcomeText: 'Begrüßungstext',
			background: 'Hintergrund',
			navigation: 'Navigation',
			primary: 'Primär',
			secondary: 'Sekundär',
			objects: 'Objekte',
			newDocuments: 'Neue Dokumente',
			reportsDeadlinesOverview: 'Meldungen Fristenübersicht',
			selectLogo: 'Logo auswählen',
			trackleanIntegration: 'Tracklean Anbindung',
			trackleanDomain: 'Tracklean Domain',
			trackleanApiKey: 'Tracklean API Schlüssel',
			protocolSavedUnderDocumentType:
				'Unter der angegebenen Dokumentenart wird das Protokoll gespeichert',
			loginGreetingTextInfo:
				'Dieser Text wird jedem Nutzer bei der Anmeldung angezeigt (optional kann der Begrüßungstext auch auf dem Dashboard dargestellt werden)',
			emailImportSend: 'Import / Versand von E-Mails',
			templateGlobalSettingsInfo:
				'Einstellungen zu den Optionen Absendername, Absenderadresse, Logo und Grußformel gelten für alle Vorlagen. Es sei denn, es ist in der jeweiligen Vorlage eine eigene Einstellung hinterlegt.',
			notificationSending: 'Versand von Benachrichtigungen',
			controlSendingPerDocumentType:
				'Sie können den Versand auch pro {link} steuern',
			autoSendWelcomeEmailsCredentials:
				'Automatischer Versand von Begrüßungsemails / Zugangsdaten',
			statusEmailSending: 'Versand von Statusemails',
			// AAR-1116 — Sammelintervall fuer Kommentar-Benachrichtigungen
			commentDigest: 'Kommentar-Benachrichtigungen bündeln',
			commentDigestInfo:
				'Benachrichtigungen zu neuen Kommentaren werden gesammelt und im gewählten Intervall in einer E-Mail verschickt.',
			commentDigestImmediate: 'Sofort',
			commentDigestMinutes: '{minutes} Minuten',
			commentDigestHourly: 'Stündlich',
			commentDigestDaily: 'Täglich',
			senderName: 'Absendername',
			replyAddress: 'Antwortadresse',
			templatePlaceholdersHint:
				'Klicken Sie einen Platzhalter an, um ihn an der Cursorposition in Betreff oder Anschreiben einzufügen. Angeboten werden nur Platzhalter, die diese Vorlage beim Versand auch befüllen kann.',
			placeholderGroups: {
				recipient: 'Empfänger',
				sender: 'Absender / Firma',
				task: 'Auftrag',
				property: 'Objekt',
				craftsman: 'Handwerker & Termine',
				report: 'Meldung',
				reviewDocument: 'Belegprüfung',
				handover: 'Übergabe',
				digest: 'Sammelmail',
				document: 'Dokumente',
				portal: 'Portal',
			},
			// Beschriftungen der Mail-Platzhalter. Einzige Quelle - wird sowohl von
			// der Chip-Auswahl im Vorlagen-Editor als auch von der "fehlende
			// Werte"-Warnung im HWA-Mail-Dialog benutzt.
			mailPlaceholders: {
				person_salutation: 'Anrede',
				person_letter_salutation: 'Briefanrede',
				person_title: 'Titel',
				person_firstname: 'Vorname',
				person_lastname: 'Nachname',
				person_fullname: 'Name',
				person_street: 'Straße',
				person_zip: 'PLZ',
				person_city: 'Ort',
				person_email: 'E-Mail / Benutzername',
				contact_person_salutation: 'Anrede',
				contact_person_letter_salutation: 'Briefanrede',
				contact_person_title: 'Titel',
				contact_person_firstname: 'Vorname',
				contact_person_lastname: 'Nachname',
				contact_person_fullname: 'Name',
				contact_person_street: 'Straße',
				contact_person_zip: 'PLZ',
				contact_person_city: 'Ort',
				contact_person_email: 'E-Mail / Benutzername',
				contact_person_logo: 'Logo',
				task_subject: '@:common.subject',
				task_number: 'Auftragsnummer',
				task_type: 'Auftragsart',
				building: 'Liegenschaft',
				unit: 'Einheit',
				status: '@:common.status',
				craftsman_name: '@:component.craftsmanTasks.craftsman',
				craftsman_email: 'Handwerker-E-Mail',
				craftsman_phone: 'Handwerker-Telefon',
				appointment_date: 'Termin',
				task_deadline: '@:common.deadline',
				sender_name: 'Absender',
				report_id: 'Meldungsnummer',
				report_type: 'Meldungsart',
				report_sub_type: 'Meldungs-Unterart',
				previous_report_status: 'Vorheriger Status',
				current_report_status: 'Aktueller Status',
				previous_assigned_team: 'Vorheriger Sachbearbeiter',
				current_assigned_team: 'Aktueller Sachbearbeiter',
				comment: 'Kommentar',
				review_document_hp_id: 'Belegprüfung-Nummer',
				review_document_name: 'Belegprüfung-Bezeichnung',
				review_document_deadline: 'Belegprüfung-Frist',
				building_hp_id: 'Liegenschaft-Nummer',
				building_street: 'Liegenschaft-Straße',
				building_zip: 'Liegenschaft-PLZ',
				building_city: 'Liegenschaft-Ort',
				unit_hp_id: 'Einheit-Nummer',
				unit_searchstring: 'Einheit-Bezeichnung',
				unit_position: 'Einheit-Lage',
				inspection_type: 'Übergabeart',
				date: 'Übergabetermin',
				digest_total: 'Kommentare gesamt',
				digest_reports_count: 'Kommentare zu Meldungen',
				digest_review_documents_count: 'Kommentare zur Belegprüfung',
				document_files_count: 'Anzahl Dokumente',
				url_home: 'Portal-Link',
			},
			selectEmailLogo: 'E-Mail Logo auswählen',
			greeting: 'Grußformel',
			mailTemplates: mailTemplates,
			additionalRecipient: 'Zusätzlicher Empfänger',
			emailBody: 'Anschreiben',
			preview: 'Vorschau',
			mailPreview: 'E-Mail Vorschau',
			reason: 'Begründung',
			sendingSettings: 'Versandeinstellungen',
			documentTypeEdit: 'Dokumentenart {acronym} bearbeiten',
			updateDocumentTypeDispatch: 'Versand der Dokumentenarten aktualisieren',
			sortOrder: 'Sortierreihenfolge',
			notificationSettings: 'Benachrichtigungseinstellungen',
			notOlderThanWeeks: 'Nicht älter als angegebene Wochen',
			abbreviation: 'Kürzel',
			quantity: 'Anzahl',
			sending: 'Versand',
			confirmDeletion:
				'Bitte bestätigen Sie, dass folgende {count} {name} gelöscht werden sollen.',
			templateName: 'Vorlage Name',
			standardTexts: 'Standardtexte',
			initialInspection: 'Erstabnahme',
			finalInspection: 'Endabnahme',
			gracePeriod: 'Nachfrist',
			createReportType: 'Meldungsart anlegen',
			createEntry: 'Eintrag anlegen',
			createSubcategory:
				'Bitte achten Sie darauf, eine Unterkategorie anzulegen. Solange keine Unterkategorie existiert, darf man keine Meldung mit dieser Kategorie erstellen.',
			entry: '@:common.entry',
			optionalDescription: '(optional) Beschreibung',
			images: 'Bilder',
			imagesTip:
				'Mit dieser Einstellung wird der Anhang eines Bildes verpflichtend',
			requireImage: 'Soll mindestens ein Bild angefügt werden?',
			requirements: 'Pflichtangaben',
			systemTypeLocked: 'Systemtypen können nicht bearbeitet werden.',
			location: 'Standort',
			locationTip: 'Mit dieser Einstellung wird das Standortfeld verpflichtend',
			locationDescription: 'Soll eine Standortbeschreibung verpflichtend sein?',
			personRoleUsage:
				'Die Personenfunktion die bei der weiteren Verarbeitung herangezogen werden soll',
			processStep: 'Prozessschritt',
		},
	},
}
